export default __webpack_public_path__ + "static/SOL-transparent-bc461a6c456af5f708a3c7d4c702682b.png";